import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs'
import Headers from '../components/Headers';

function Portfolio(props) {
  const link = props.linksDs.find(link => link.link === '/portfolio');
  const pageTitle = props.lang === 'en' ? link.name_en : link.name_se;
  return (
    <>
      <Headers title={pageTitle} lang={props.lang} clink='/portfolio' />
      <Breadcrumbs
        title={pageTitle} lang={props.lang} bgimg="https://mhs.mharis.info/wp-content/uploads/2023/04/bg-about-tms-banner.jpg" />
      <div>Portfolio</div>
    </>

  )
}

export default Portfolio
